/** Loose mailbox shape shared by the Self-Serve landing forms and the forgot API. */
const EMAIL_PATTERN = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

/** RFC 5321 maximum mailbox length. Matches {@code FieldLimits.EMAIL_MAX_LENGTH}. */
export const EMAIL_MAX_LENGTH = 254;

/**
 * Whether the text looks like one mailbox. Shape only; no length or blank check.
 *
 * @param trimmed email with surrounding whitespace already removed
 */
export const isEmailShape = (trimmed: string): boolean => EMAIL_PATTERN.test(trimmed);

/**
 * Not blank, within {@link EMAIL_MAX_LENGTH}, and the right shape. The forgot API applies
 * the same rules.
 *
 * @param trimmed email with surrounding whitespace already removed
 */
export const isValidSelfServeEmail = (trimmed: string): boolean =>
  !!trimmed && trimmed.length <= EMAIL_MAX_LENGTH && isEmailShape(trimmed);
